import { composeIO } from 'react-compose-io'
import { detalhesOpsEmAbertoIO } from './DetalhesOpsEmAberto.IO'
import { DetalhesOpsEmAbertoView } from './DetalhesOpsEmAberto.View'

export const DetalhesOpsEmAberto = composeIO(DetalhesOpsEmAbertoView, detalhesOpsEmAbertoIO)
